import { render } from "./UserHeader.vue?vue&type=template&id=ae3c27b6&scoped=true"
import script from "./UserHeader.vue?vue&type=script&lang=js"
export * from "./UserHeader.vue?vue&type=script&lang=js"

import "./UserHeader.vue?vue&type=style&index=0&id=ae3c27b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae3c27b6"]])

export default __exports__